import { GET, POST, DELETE, webhookRoutes } from 'constants/api';
import api from 'services/api';

const MISSING_WEBHOOK_ID = 'Webhook id is missing';

const checkWebhookId = webhookId => {
  if (!webhookId && webhookId !== 0) {
    throw new Error(MISSING_WEBHOOK_ID);
  }
};

export const getWebhooksForTemplate = templateId => {
  checkWebhookId(templateId);
  return api({
    method: GET,
    url: `${webhookRoutes.GET_WEBHOOKS}${templateId}`,
  });
};

export const getAllWebhooks = () => {
  return api({
    method: GET,
    url: webhookRoutes.GET_ALL_WEBHOOKS,
  });
};

export const createWebhook = data => {
  return api({
    method: POST,
    url: webhookRoutes.ADD_WEBHOOK,
    data,
  });
};

export const deleteWebhook = webhookId => {
  checkWebhookId(webhookId);
  return api({
    method: DELETE,
    url: `${webhookRoutes.DELETE_WEBHOOK}${webhookId}`,
  });
};
